import React from "react";
import { Link } from "react-router-dom";
import "../css/JobBoardList.css"; // CSS 파일에서 스타일 적용

const JobBoardList = () => {
  return (
    <div className="job-board-container">
      <h1>구인/구직</h1>
      <ul className="job-categories">
        <li>운전직(승무사원)</li>
        <li>정비직</li>
        <li>사무직</li>
      </ul>
      <div className="job-buttons-container">
        <Link to="/jobpostings">
          <button className="job-button job-button-postings">
            구인
            <br />
            바로가기
          </button>
        </Link>
        <Link to="/jobseekers">
          <button className="job-button job-button-seekers">
            구직
            <br />
            바로가기
          </button>
        </Link>
      </div>
      <div className="job-image">
        <img src="bus_image.png" alt="버스 이미지" />{" "}
        {/* 이미지 경로는 실제 이미지 경로로 수정하세요 */}
      </div>
    </div>
  );
};

export default JobBoardList;
